// utils/soundGenerator.js
class SoundGenerator {
  constructor() {
    this.audioContext = null;
    this.init();
  }

  async init() {
    try {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
    } catch (error) {
      console.warn('Web Audio API not supported:', error);
    }
  }

  playBeep(frequency = 800, duration = 200, volume = 0.1) {
    if (!this.audioContext) return;

    const oscillator = this.audioContext.createOscillator();
    const gainNode = this.audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(this.audioContext.destination);

    gainNode.gain.value = volume;
    oscillator.frequency.value = frequency;
    oscillator.type = 'sine';

    oscillator.start();
    gainNode.gain.exponentialRampToValueAtTime(0.001, this.audioContext.currentTime + duration / 1000);
    oscillator.stop(this.audioContext.currentTime + duration / 1000);
  }

  playNotificationSound(type) {
    const sounds = {
      urgent: () => this.playBeep(1000, 300, 0.2),
      meeting: () => this.playBeep(600, 500, 0.15),
      message: () => this.playBeep(800, 200, 0.1),
      success: () => {
        this.playBeep(1000, 150, 0.1);
        setTimeout(() => this.playBeep(1200, 150, 0.1), 160);
      },
      default: () => this.playBeep(700, 250, 0.1)
    };

    const playSound = sounds[type] || sounds.default;
    playSound();
  }
}

const soundGenerator = new SoundGenerator();
export default soundGenerator;